import React, { useState } from 'react'
import { useHistory } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ButtonTypes, Alert, Input, MoContainer, MoLink, Button, MoSpan } from '../Mo7/mo7UI';
import { cols, icons } from '../services/design.sevice';
import styled from "styled-components"

export default function Signup() {
    const [{ displayName, email, password, password2 }, setInputValues] = useState({ displayName: "", email: "", password: "", password2: "" })
    const history = useHistory()
    const { signup, updateDisplayNameAndPhoto } = useAuth()

    //image priview
    const [imagePreview, setImagePreview] = useState(null)

    //Error and messages
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)

    function handleInputChange(e) {
        const { name, value } = e.target;
        setInputValues((prev) => ({
            ...prev, [name]: value
        }))
    }
    function handlepdateProfilePic(e) {
        setImagePreview(null)
        const file = e.target.files[0]
        if (file && file == null) return setImagePreview(null);
        setImagePreview(file)
    }
    async function handleSignup(e) {
        setError("")
        e.preventDefault();
        //check image
        if (!imagePreview || imagePreview.size < 10) {
            return setError("must upload profile picture !")
        }
        //check image
        if (!imagePreview || imagePreview.size > 2097152) {
            return setError("profile picture size must be less than 2MB !")
        }

        // chack if password matches
        if (displayName.length < 8) {
            return setError("name must have at least 6 characters !")
        }
        // chack if password matches
        if (password !== password2) {
            return setError("Passwords don't match !")
        }
        // chack if password matches
        if (password.length < 8) {
            return setError("Passwords must have at least 8 characters !")
        }

        //signup here
        var success = false;
        try {
            setError("")
            setLoading(true)
            await signup(email, password)
            await updateDisplayNameAndPhoto(displayName ,imagePreview)
            
            success = true

        } catch (err) {
            setError("Failed to sign up :" + err)
            success = false
        }
        if (success) {
            history.push("/dashboard/home")
        } else {
            setLoading(false)
        }
    }
    return (
        <MoContainer flex >
            <ContainerLHalf>

                <MoContainer gap="0" h="90%" flex_dir_c flex align="center" justify="center">
                    <MoSpan pd={{ tb: "1rem" }}>Join Us,</MoSpan>
                    <img src={icons.logo_text} alt="" />
                </MoContainer>
                <MoContainer w="100%">
                    <MoContainer flex pd={{ l: "2rem" }} >
                        <img height='20px' src={icons.ic_return} alt="" />
                        <MoLink to="/home">Home</MoLink>
                    </MoContainer>
                </MoContainer>
            </ContainerLHalf>
            {/* Right half */}
            <MoContainer w="50%" flex flex_dir_c>
                <MoContainer flex align="end">
                    <MoLink m_l="auto" to="/signin">
                        <MoContainer m_t="1rem" flex align="center">
                            Already have an account ?
                        <Button w="10rem" b_r="5px" pd={{ lr: "15px" }} m_r="1rem" type={ButtonTypes.shadowed} title="Sign In" />
                        </MoContainer>
                    </MoLink>
                </MoContainer>

                <MoContainer grid tem_c="1fr 1fr">
                    <ContainerSignForm>
                        <MoSpan pd={{ tb: "3rem" }}>Sign Up</MoSpan>
                        <form onSubmit={handleSignup}>
                            <Input type="text" required value={displayName} onChange={handleInputChange} name="displayName" pholder="your name" icon={icons.ic_profile} />
                            <Input type="text" required value={email} onChange={handleInputChange} name="email" pholder="email" icon={icons.ic_email} />
                            <Input type="password" required onChange={handleInputChange} name="password" pholder="password" icon={icons.ic_password} />
                            <Input type="password" required onChange={handleInputChange} name="password2" pholder="confirm password" icon={icons.ic_password} />

                            <Button pd={{ lr: "3rem" }} type={loading?ButtonTypes.shadowed:ButtonTypes.filled} title={loading?"signing in ...":"Signup"} disabled={loading} />
                        </form>


                    </ContainerSignForm>
                    {/* upload image */}
                    <MoContainer flex flex_dir_c justify="space-between" align="center" >
                        {/* image preview */}
                        <MoContainer border={{ w: "2px", col: cols.main_purple }} m_t="1rem" b_r={{ all: "50%" }} wh="15rem" bg_i={imagePreview ? URL.createObjectURL(imagePreview) : "https://firebasestorage.googleapis.com/v0/b/sfe-tutor-bolt.appspot.com/o/img_profile_picture.jpg?alt=media&token=79fa179b-c6ac-4518-be62-5030047f3610"} />
                        <MoSpan fs_sml >This will be your profile picture ,make sure it's perfect !</MoSpan>
                        <MoContainer pos="relative" b_r={{ all: "1rem" }} border={{ w: "1px", col: cols.main_purple }} pd={{ tb: "10px", lr: "25px" }} eff_shdw={{ op: .15 }} grid place="center">
                            <MoSpan f_w="600" fs_sml>Upload</MoSpan>
                            <input type="file" accept="image/*" onChange={handlepdateProfilePic} style={{ position: 'absolute', opacity: 0 }} />
                        </MoContainer>
                    </MoContainer>
                </MoContainer>
                <MoContainer grid place="center">
                    {error && <Alert danger >{error}</Alert>}
                </MoContainer>

                <MoContainer flex pos="fixed" pos_dir={{ r: "1rem", b: '1rem' }} m_t='auto' >
                    <img width="100px" src={icons.logo1} alt="" />
                </MoContainer>

            </MoContainer>

        </MoContainer>
    )
}

//#region styling

//#region Left half
const ContainerLHalf = styled.div`
    width: 50%;
    height: 100vh;
    background-color : ${cols.mainLight_1};
    display: flex;
    flex-direction: column;
    place-items :center;
    `;
//#endregion
//#region Righ half
const ContainerSignForm = styled.div`    
    display: flex;
    flex-direction: column;
    place-items :center;

    >form{
        display: flex;
        flex-direction: column;
        gap:1rem;
    }
    `;

